import * as React from "react";

import { trpc, trpcUtils } from "@editor/utils/trpc";

import Button from "@replo/design-system/components/button/Button";
import { Modal } from "@replo/design-system/components/modal/Modal";

type DeleteFunnelModalProps = {
  open: boolean;
  onClose: () => void;
  funnelId: string;
  projectId: string;
};

const DeleteFunnelModal: React.FC<DeleteFunnelModalProps> = ({
  open,
  onClose,
  funnelId,
  projectId,
}) => {
  const { mutate: deleteFunnel, isPending } =
    trpc.funnel.deleteFunnel.useMutation({
      onSuccess: () => {
        void trpcUtils.funnel.list.invalidate();
        onClose();
      },
    });

  return (
    <Modal
      title="Delete Funnel"
      isOpen={open}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
      size="sm"
      footer={
        <div className="flex flex-row gap-2">
          <Button variant="secondary" size="base" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="danger"
            size="base"
            onClick={() => {
              void deleteFunnel({
                funnelId,
                projectId,
              });
            }}
            isLoading={isPending}
          >
            Delete Funnel
          </Button>
        </div>
      }
    >
      <div>
        <p className="text-muted">
          Are you sure you want to delete this funnel? This action cannot be
          undone.
        </p>
      </div>
    </Modal>
  );
};

export default DeleteFunnelModal;
